import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { track } from '../../../../tracking/track';
import { events } from '../../../../tracking/events';
import { getCommerceHomeProcessorPickerIframeOpenURL, getPaymentLinksURL, getCreateInvoicesURL, getBillingWizardURL } from 'growth-payments-core/urls/urls';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import ModalWrapper from '../../ModalWrapper';
import { ListItemWithIcon } from '../../shared';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ToolModalPrimaryButton = props => /*#__PURE__*/_jsx(Button, Object.assign({
  use: "primary",
  "data-test-id": "set-up-payments-button"
}, props));
const SetUpPaymentsReportingModal = ({
  handleInterstitialModalClose,
  screen
}) => {
  const trackButtonClick = useCallback(trackValue => {
    track(events.paymentsInterstitialModalInteraction, {
      action: 'click',
      screen,
      value: `createTool-${trackValue}`
    });
  }, [screen]);
  const createPaymentLinkButton = /*#__PURE__*/_jsx(Button, {
    href: `${getPaymentLinksURL()}/create`,
    onClick: () => trackButtonClick('payments'),
    external: true,
    "data-test-id": "create-payment-link-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.ctas.createAPaymentLink"
    })
  });
  const createInvoiceButton = /*#__PURE__*/_jsx(Button, {
    href: getCreateInvoicesURL(),
    onClick: () => trackButtonClick('invoices'),
    external: true,
    "data-test-id": "create-invoice-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.ctas.createAnInvoice"
    })
  });
  const createSubscriptionButton = /*#__PURE__*/_jsx(Button, {
    href: getBillingWizardURL(),
    onClick: () => trackButtonClick('subscriptions'),
    external: true,
    "data-test-id": "create-subscription-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.ctas.createASubscription"
    })
  });
  const ToolSelectionDropdown = props => /*#__PURE__*/_jsx(Dropdown, Object.assign({
    "data-test-id": "tool-selection-dropdown",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.ctas.collectPaymentsWithTools"
    }),
    placement: "bottom"
  }, props, {
    children: /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: createPaymentLinkButton
      }), /*#__PURE__*/_jsx(ListItem, {
        children: createInvoiceButton
      }), /*#__PURE__*/_jsx(ListItem, {
        children: createSubscriptionButton
      })]
    })
  }));
  const modalName = 'createToolModal.setUpPayments';
  const Body = /*#__PURE__*/_jsxs(List, {
    marginBlockStart: "300",
    children: [/*#__PURE__*/_jsx(ListItemWithIcon, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "embedPoints.createToolModal.setUpPayments.p1"
      })
    }), /*#__PURE__*/_jsx(ListItemWithIcon, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "embedPoints.createToolModal.setUpPayments.p2"
      })
    }), /*#__PURE__*/_jsx(ListItemWithIcon, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "embedPoints.createToolModal.setUpPayments.p3"
      })
    })]
  });
  const Footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ToolModalPrimaryButton, {
      href: getCommerceHomeProcessorPickerIframeOpenURL(),
      onClick: () => trackButtonClick('setUpPayments'),
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.ctas.goToPayments"
      })
    }), /*#__PURE__*/_jsx(ToolSelectionDropdown, {})]
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: handleInterstitialModalClose,
    modalName: modalName,
    modalSubTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.createToolModal.setUpPayments.subTitle"
    }),
    Body: Body,
    Footer: Footer,
    illustrationName: "payments",
    paddingBlockStart: "1200",
    paddingBlockEnd: "500",
    paddingInlineEnd: "1000"
  });
};
export default SetUpPaymentsReportingModal;